<ac-input-container label="Operator Type" [displayAsInfo]="true">
    <ac-textfield [acModel]="operatorType"
                  [attr.alternativeName]="'operatorType'"
                  [ngDisabled]="true" textFieldId="operator-basic-info-type">
    </ac-textfield>
</ac-input-container>

<ac-input-container label="Operator Name">
    <ac-textfield [acModel]="operator.name || additionalSettings.name"
                  (acModelChange)="operator.name = $event"
                  [attr.alternativeName]="'operator.name'"
                  [ngDisabled]="isEdit"
                  textFieldId="operator-form-user-name">
    </ac-textfield>
</ac-input-container>

<div class="flexRowParentEqualChildren">
    <ac-input-container editModePrefix="Change" label="Password">
        <ac-password [(acModel)]="operator.password" [showEye]="true"
                     [attr.alternativeName]="'operator.password'"
                     passwordId="operator-form-password">
        </ac-password>
    </ac-input-container>

    <ac-input-container label="Confirm Password">
        <ac-password [(acModel)]="additionalSettings.confirmPassword" [showEye]="true"
                     [attr.alternativeName]="'additionalSettings.confirmPassword'"
                     passwordId="operator-form-confirm-password"
                     textFieldId="operator-basic-info-type-confirm-password">
        </ac-password>
    </ac-input-container>
</div>

<ac-checkbox labelText="Change Password on Next Login"
             [(acModel)]="operator.changePasswordOnNextLogin"
             [attr.alternativeName]="'operator.changePasswordOnNextLogin'"
             checkboxId="operator-form-change-password">
</ac-checkbox>

<ac-input-container label="Security Level">
    <ac-single-select [(acModel)]="operator.securityLevel"
               (acModelChange)="securityLevelChanged();"
               [attr.alternativeName]="'operator.securityLevel'"
               [bindLabel]="'viewName'"
               [bindValue]="'name'"
               [items]="securityLevelOptions">
    </ac-single-select>
</ac-input-container>

<ac-checkbox labelText="HTTP Rest operator"
             *ngIf="oneLiveMode && operator.isSystemOperator && operator.securityLevel === 'OPERATOR'"
             [(acModel)]="operator.isUMP">
</ac-checkbox>

<ac-input-container label="Valid IPs to Login From">
    <ac-select [(acModel)]="operator.loginFromIps"
               [addCustomTags]="true"
               [attr.alternativeName]="'operator.loginFromIps'"
               [bindLabel]="null" [bindValue]="null"
               [multiple]="true"
               selectionName="operator.loginFromIps">
    </ac-select>
</ac-input-container>

<div class="flexRowParentEqualChildren">
    <ac-input-container label="Full Name">
        <ac-textfield [(acModel)]="operator.fullName"
                      [attr.alternativeName]="'operator.fullName'"
                      textFieldId="operator-form-full-name">
        </ac-textfield>
    </ac-input-container>

    <ac-input-container label="Phone">
        <ac-textfield [(acModel)]="operator.phone"
                      [attr.alternativeName]="'operator.phone'"
                      textFieldId="operator-form-phone">
        </ac-textfield>
    </ac-input-container>
</div>

<div class="flexRowParentEqualChildren">
    <ac-input-container label="Email">
        <ac-textfield [(acModel)]="operator.mail"
                      [attr.alternativeName]="'operator.mail'"
                      textFieldId="operator-form-mail">
        </ac-textfield>
    </ac-input-container>

    <ac-input-container label="Description">
        <ac-textfield [(acModel)]="operator.description"
                      [attr.alternativeName]="'operator.description'"
                      textFieldId="operator-form-description">
        </ac-textfield>
    </ac-input-container>
</div>



